export default{
    message: {

       injury_side:'Сторона травмы',
        prosthetics_side:'Сторона протезирования',
        fingertip_color:'Цвет напалечников',
        wrist_color:'Цвет руки',
        arch_color:'Цвет арки',
        finger_color:'Цвет пальцев',
        forearm_color:'Цвет предплечья',
        cut:'Вырез',
        left:'Лево',
        right:'Право',
        two:'Обе',
        form_a_request:'Отправить заявку',
        send:'Отправить',
        phone:'Телефон',
        email:'Email',
        deal_id:'Номер договора',
        comment:'Коментарий',
        fio:'Ф.И.О.',
        error:'Произошла непредвиденная ошибка попробуйте позднее',
        deal_not_exist:'Такого номера договора не существует',
        info_title:'Контактная информация',
        bad_email:'Неверный формат Email',
        bad_phone:'Неверный формат Телефона',
        field_require:'Заполните поле',
        deal_num_cond:'Номер договора олжен состоять минимум из 6 цифр',
        deal_id_dig:'Номер договора должен состоять только из цифр',
        success_message_1:'Поздравляем, Ваша конфигурация дизайна протеза Киби отправлена!',
        success_message_2:'В ближайшее время наш специалист свяжется с вами для обсуждения дальнейших этапов.',
        
    }   
}